import { render, staticRenderFns } from "./inquiry-input.vue?vue&type=template&id=caf59692&scoped=true&"
import script from "./inquiry-input.vue?vue&type=script&lang=js&"
export * from "./inquiry-input.vue?vue&type=script&lang=js&"
import style0 from "./inquiry-input.vue?vue&type=style&index=0&id=caf59692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf59692",
  null
  
)

export default component.exports